async function renderCartUpsell() {
  const container = document.getElementById('CartDrawer-Upsell');
  if (!container) return;

  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  const cartProductIds = [...new Set(cart.items.map((i) => i.product_id))];

  if (cartProductIds.length === 0) {
    container.innerHTML = '';
    return;
  }

  const results = await Promise.all(
    cartProductIds.map((id) =>
      fetch(`/recommendations/products.json?product_id=${id}&intent=complementary&limit=8`)
        .then((r) => r.json())
        .then((data) => data.products || [])
        .catch(() => [])
    )
  );

  const seen = new Set(cartProductIds);
  const upsellProducts = [];
  results.flat().forEach((p) => {
    if (!seen.has(p.id)) {
      seen.add(p.id);
      upsellProducts.push(p);
    }
  });

  if (upsellProducts.length === 0) {
    container.innerHTML = '';
    return;
  }

  container.innerHTML = `
    <p class="cart-drawer__upsell-title">Pairs well with</p>
    <div class="cart-drawer__upsell-list">
      ${upsellProducts
        .slice(0, 6)
        .map(
          (p) => `
        <div class="cart-drawer__upsell-item">
          <img src="${p.featured_image?.url || p.images[0]}" width="60" height="60" alt="${p.title}">
          <div class="cart-drawer__upsell-info">
            <span class="cart-drawer__upsell-name">${p.title}</span>
            <span class="cart-drawer__upsell-price-wrapper">
              ${
                p.compare_at_price && p.compare_at_price > p.price
                  ? `<s class="cart-drawer__upsell-compare-price">${(p.compare_at_price / 100).toFixed(2)} ${cart.currency}</s>`
                  : ''
              }
              <span class="cart-drawer__upsell-price">${(p.price / 100).toFixed(2)} ${cart.currency}</span>
            </span>
          </div>
          <button type="button" class="button button--tertiary cart-drawer__upsell-add" data-variant-id="${p.variants[0].id}">
            Add to cart
          </button>
        </div>`
        )
        .join('')}
    </div>
  `;

  container.querySelectorAll('.cart-drawer__upsell-add').forEach((btn) => {
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      btn.textContent = 'Adding...';
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
      });
      window.location.reload();
    });
  });
}

const cartNotificationTarget = document.getElementById('cart-notification');
if (cartNotificationTarget) {
  const observer = new MutationObserver(() => {
    clearTimeout(window.__cartUpsellTimeout);
    window.__cartUpsellTimeout = setTimeout(renderCartUpsell, 150);
  });
  observer.observe(cartNotificationTarget, { childList: true, subtree: true, attributes: true });
}

document.addEventListener('DOMContentLoaded', renderCartUpsell);